<script setup>
import { ref, computed } from "vue";
import UploadingItem from "@/Components/Uploads/UploadingItem.vue";
import DropZoneSVG from "@/images/DropZoneSVG.vue";

const dropzoneActive = ref(false);

const fileInput = ref(null);

//prevent flickering as drag event enters children

let inActiveTimeout = null;

const props = defineProps({
    uploads: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits([
	'upload-complete'
])

//handle style changes when dropzone is active

function setActive() {
    dropzoneActive.value = true;
    clearTimeout(inActiveTimeout);
}

function setInActive() {
    inActiveTimeout = setTimeout(() => {
        dropzoneActive.value = false;
    }, 50);
}

function uploadComplete(file) {
	emit('upload-complete', file)
}
</script>

<template>
    <div
        @drop.prevent="onDrop"
        @dragover.prevent="setActive"
        @dragleave="setInActive"
        @dragenter.prevent="setActive"
        @click="onClick"
        class="
            h-48
            flex flex-col
            justify-center
            items-center
            cursor-pointer
            mb-4
        "
    >
        <DropZoneSVG />

        <h2 class=" text-center px-4">Drop files anywhere or click to upload</h2>
    </div>
    <div v-if="props.uploads.length > 0" class="mt-4">
        <h2 v-if="props.uploads.length > 1" class="mb-4">
            Uploading {{ props.uploads.length }} files..
        </h2>
        <h2 v-else  class="mb-4">
            Uploading 1 file..
        </h2>

        <div 
			v-for="file in props.uploads" 
			:key='file.name'
		>
            <UploadingItem 
				:file="file" 
				@upload-complete="uploadComplete(file)"
			/>
        </div>
    </div>
</template>
